(function () {
  'use strict';
  var panels = Array.from(document.querySelectorAll('[data-casewale-facets]'));
  var grid = document.querySelector('.cw26-col-grid');
  var count = document.querySelector('[data-casewale-count]');
  var pagination = document.querySelector('[data-casewale-pagination]');
  if (!panels.length || !grid || !count || !pagination) return;
  var path = location.pathname;
  var symbol = grid.dataset.currencySymbol || '₹';
  var perPage = Number(grid.dataset.casewalePerPage || 24);
  var query = new URLSearchParams(location.search);
  var selected = {
    model: new Set(query.getAll('cw_model')),
    color: new Set(query.getAll('cw_color')),
    feature: new Set(query.getAll('cw_feature'))
  };
  var products = [];
  var currentPage = 1;
  var lower = 0;
  var upper = 1;
  var minPrice = query.has('cw_price_min') ? Number(query.get('cw_price_min')) : null;
  var maxPrice = query.has('cw_price_max') ? Number(query.get('cw_price_max')) : null;
  var escapeHtml = function (v) {
    return String(v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});
  };
  var escapeAttr = escapeHtml;
  var hasSelection = function () { return selected.model.size || selected.color.size || selected.feature.size || minPrice !== null || maxPrice !== null; };
  var featureList = ['MagSafe Compatible','Shockproof','Glitter Finish','Anti-Yellowing','Camera Protection','Wireless Charging','Slim & Lightweight'];
  var matchesFeature = function (p, f) {
    var text = ((p.title||'')+' '+(p.tags||[]).join(' ')).toLowerCase();
    if(f==='MagSafe Compatible')return /magsafe|magnetic/.test(text);
    if(f==='Shockproof')return /shockproof|tough|military/.test(text);
    if(f==='Glitter Finish')return /glitter|sparkle|bling/.test(text);
    if(f==='Anti-Yellowing')return /anti.yellow|anti yellow/.test(text);
    if(f==='Camera Protection')return /camera|lens/.test(text);
    if(f==='Wireless Charging')return /wireless charging/.test(text);
    return /slim|ultra thin|lightweight/.test(text);
  };
  var endpoint = function (page) {
    var params = new URLSearchParams(location.search);
    ['view','page','cw_model','cw_color','cw_feature','cw_price_min','cw_price_max','filter.v.price.gte','filter.v.price.lte'].forEach(function(k){params.delete(k);});
    params.set('view','casewale-filter');
    params.set('page',String(page));
    return path+'?'+params.toString();
  };
  var getPage = async function(page) {
    var response = await fetch(endpoint(page),{credentials:'same-origin'});
    if(!response.ok)throw new Error('Filter data unavailable');
    var data = await response.json();
    if(!Array.isArray(data.products))throw new Error('Invalid filter data');
    return data;
  };
  var options = function (key) {
    var map = new Map();
    products.forEach(function(p){
      var values = key==='feature' ? featureList.filter(function(f){return matchesFeature(p,f);}) : (p[key+'s']||[]);
      new Set(values).forEach(function(v){map.set(v,(map.get(v)||0)+1);});
    });
    return Array.from(map).sort(function(a,b){return a[0].localeCompare(b[0],undefined,{numeric:true});});
  };
  var swatchColor = function (name) {
    var palette = {burgundy:'#8c133c',orange:'#f07722',gold:'#c6a15e',silver:'#d7d8dd',blue:'#548bc3',black:'#27262a',white:'#f4f4f5',pink:'#e89aad',purple:'#9a7bbd',red:'#bf163d',green:'#759f77'};
    return palette[String(name).toLowerCase()] || String(name).toLowerCase().replace(/[^a-z]/g,'') || '#ddd';
  };
  var listHtml = function (key, values) {
    return values.map(function(pair){
      var value=pair[0], n=pair[1];
      return '<label class="casewale-facet-option"><input type="checkbox" data-cw-facet="'+key+'" value="'+escapeAttr(value)+'"'+(selected[key].has(value)?' checked':'')+'>'+(key==='color'?'<span class="casewale-facet-swatch" style="--swatch:'+escapeAttr(swatchColor(value))+'"></span>':'')+'<span>'+escapeHtml(value)+'</span><small>('+n+')</small></label>';
    }).join('');
  };
  var priceHtml = function () {
    var min = Math.max(lower,Math.min(upper,minPrice === null ? lower : minPrice));
    var max = Math.max(min,Math.min(upper,maxPrice === null ? upper : maxPrice));
    var span = upper-lower || 1;
    return '<details class="casewale-facet-group" open><summary>Price Range</summary><div class="casewale-price-fields"><label>'+escapeHtml(symbol)+'<input type="number" data-cw-price="min" aria-label="Minimum price" min="'+lower+'" max="'+upper+'" value="'+min+'"></label><span>–</span><label>'+escapeHtml(symbol)+'<input type="number" data-cw-price="max" aria-label="Maximum price" min="'+lower+'" max="'+upper+'" value="'+max+'"></label></div><div class="casewale-price-slider" style="--from:'+(100*(min-lower)/span)+'%;--to:'+(100*(max-lower)/span)+'%"><input type="range" data-cw-range="min" aria-label="Minimum price slider" min="'+lower+'" max="'+upper+'" value="'+min+'"><input type="range" data-cw-range="max" aria-label="Maximum price slider" min="'+lower+'" max="'+upper+'" value="'+max+'"></div><div class="casewale-price-pips"><span>'+escapeHtml(symbol)+lower+'</span><span>'+escapeHtml(symbol)+upper+'</span></div></details>';
  };
  var renderPanels = function () {
    var groups=[['model','iPhone Model'],['color','Color'],['feature','Features']];
    var body='<div class="casewale-facet-heading"><strong>Filters</strong><button class="casewale-facet-clear" type="button" data-cw-clear>Clear All</button></div>';
    groups.forEach(function(group){
      var values=options(group[0]);
      if(values.length)body+='<details class="casewale-facet-group" open><summary>'+group[1]+'</summary><div class="casewale-facet-values">'+listHtml(group[0],values)+'</div></details>';
      if(group[0]==='color')body+=priceHtml();
    });
    panels.forEach(function(panel){panel.innerHTML=body;});
  };
  var matches = function (p) {
    return (!selected.model.size || (p.models||[]).some(function(v){return selected.model.has(v);})) &&
      (!selected.color.size || (p.colors||[]).some(function(v){return selected.color.has(v);})) &&
      (!selected.feature.size || Array.from(selected.feature).every(function(f){return matchesFeature(p,f);})) &&
      (minPrice === null || Number(p.price)>=minPrice) &&
      (maxPrice === null || Number(p.price)<=maxPrice);
  };
  var syncUrl = function () {
    var params=new URLSearchParams(location.search);
    ['view','page','cw_model','cw_color','cw_feature','cw_price_min','cw_price_max'].forEach(function(k){params.delete(k);});
    ['model','color','feature'].forEach(function(key){selected[key].forEach(function(value){params.append('cw_'+key,value);});});
    if(minPrice!==null)params.set('cw_price_min',String(minPrice));
    if(maxPrice!==null)params.set('cw_price_max',String(maxPrice));
    history.replaceState(null,'',path+(params.size?'?'+params.toString():''));
  };
  var renderResults = function () {
    if(!hasSelection()){location.href=path+(new URLSearchParams(location.search).has('sort_by')?'?sort_by='+encodeURIComponent(new URLSearchParams(location.search).get('sort_by')):'');return;}
    var result=products.filter(matches);
    var pages=Math.max(1,Math.ceil(result.length/perPage));
    currentPage=Math.min(currentPage,pages);
    grid.innerHTML=result.slice((currentPage-1)*perPage,currentPage*perPage).map(function(p){return p.html;}).join('') || '<p class="cw26-collection__empty">No products match these filters.</p>';
    count.textContent=result.length+' products';
    var buttons=[];
    if(currentPage>1)buttons.push([currentPage-1,'‹']);
    for(var i=Math.max(1,currentPage-2);i<=Math.min(pages,currentPage+2);i++)buttons.push([i,String(i)]);
    if(currentPage<pages)buttons.push([currentPage+1,'›']);
    pagination.innerHTML=pages>1?'<nav class="casewale-filter-pagination" aria-label="Product pages">'+buttons.map(function(item){return '<button type="button" data-cw-page="'+item[0]+'"'+(item[0]===currentPage?' aria-current="page"':'')+'>'+item[1]+'</button>';}).join('')+'</nav>':'';
    document.dispatchEvent(new Event('casewale:products-rendered'));
  };
  var updatePriceUi = function (panel, min, max) {
    var minInput=panel.querySelector('[data-cw-price="min"]'),maxInput=panel.querySelector('[data-cw-price="max"]');
    if(!minInput||!maxInput)return;
    minInput.value=min;maxInput.value=max;
    panel.querySelector('[data-cw-range="min"]').value=min;
    panel.querySelector('[data-cw-range="max"]').value=max;
    var slider=panel.querySelector('.casewale-price-slider'),span=upper-lower||1;
    slider.style.setProperty('--from',100*(min-lower)/span+'%');
    slider.style.setProperty('--to',100*(max-lower)/span+'%');
  };
  document.addEventListener('change',function(e){
    var checkbox=e.target.closest('[data-cw-facet]');
    if(checkbox&&panels.some(function(p){return p.contains(checkbox);})){
      var values=selected[checkbox.dataset.cwFacet];
      checkbox.checked?values.add(checkbox.value):values.delete(checkbox.value);
      currentPage=1;syncUrl();renderPanels();renderResults();return;
    }
    if(e.target.matches('[data-cw-price],[data-cw-range]')){
      var parent=e.target.closest('.casewale-facet-panel');
      var min=Number(parent.querySelector('[data-cw-price="min"]').value);
      var max=Number(parent.querySelector('[data-cw-price="max"]').value);
      min=Math.max(lower,Math.min(upper,min));
      max=Math.max(min,Math.min(upper,max));
      minPrice=min<=lower?null:min;maxPrice=max>=upper?null:max;
      currentPage=1;syncUrl();renderPanels();renderResults();
    }
  });
  document.addEventListener('input',function(e){
    if(!e.target.matches('[data-cw-range]'))return;
    var panel=e.target.closest('.casewale-facet-panel');
    var min=Number(panel.querySelector('[data-cw-range="min"]').value);
    var max=Number(panel.querySelector('[data-cw-range="max"]').value);
    if(e.target.dataset.cwRange==='min')min=Math.min(min,max);
    else max=Math.max(max,min);
    panels.forEach(function(p){updatePriceUi(p,min,max);});
  });
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cw-clear]')){
      var params=new URLSearchParams(location.search);
      ['view','page','cw_model','cw_color','cw_feature','cw_price_min','cw_price_max'].forEach(function(k){params.delete(k);});
      location.href=path+(params.size?'?'+params.toString():'');return;
    }
    var button=e.target.closest('[data-cw-page]');
    if(button){currentPage=Number(button.dataset.cwPage);renderResults();grid.scrollIntoView({behavior:'smooth',block:'start'});}
  });
  var sortForm=document.querySelector('#CasewaleSort')?.form;
  if(sortForm)sortForm.addEventListener('submit',function(){
    var params=new URLSearchParams(location.search);
    ['cw_model','cw_color','cw_feature','cw_price_min','cw_price_max'].forEach(function(key){
      params.getAll(key).forEach(function(value){
        var field=document.createElement('input');field.type='hidden';field.name=key;field.value=value;sortForm.appendChild(field);
      });
    });
  });
  panels.forEach(function(p){p.innerHTML='<p class="casewale-facet-status">Loading filters…</p>';});
  (async function(){
    try{
      var first=await getPage(1);
      products=first.products;
      for(var i=2;i<=first.pages;i+=3){
        var batch=[];
        for(var j=i;j<Math.min(i+3,first.pages+1);j++)batch.push(getPage(j));
        (await Promise.all(batch)).forEach(function(page){products.push.apply(products,page.products);});
      }
      var prices=products.map(function(p){return Number(p.price);}).filter(Number.isFinite);
      lower=prices.length?Math.floor(Math.min.apply(null,prices)):0;
      upper=prices.length?Math.ceil(Math.max.apply(null,prices)):1;
      if(upper<=lower)upper=lower+1;
      renderPanels();
      if(hasSelection())renderResults();
    }catch(e){
      panels.forEach(function(p){p.innerHTML='<p class="casewale-facet-status">Filters are temporarily unavailable.</p>';});
    }
  })();
})();
